import { render, staticRenderFns } from "./HotReloadMonitor.vue?vue&type=template&id=ca802a3c"
var script = {}
import style0 from "./HotReloadMonitor.vue?vue&type=style&index=0&id=ca802a3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports